<div class="signup-form container">
    <form (submit)="submit(); $event.preventDefault()">
        <h2>{{ useRecoveryCode ? 'Recovery code' : 'Authenticator code' }}</h2>
        <p class="hint-text">
            @if (useRecoveryCode) {
                Enter one of the one-time recovery codes you saved when you set up MFA.
            } @else {
                Open Microsoft Authenticator or Google Authenticator and enter the 6-digit code.
            }
        </p>
        <div class="form-group">
            <input
                type="text"
                class="form-control"
                [(ngModel)]="code"
                name="code"
                [placeholder]="useRecoveryCode ? 'Recovery code' : '6-digit code'"
                autocomplete="one-time-code"
                inputmode="numeric"
                required
            />
        </div>
        @if (!useRecoveryCode) {
            <div class="form-group">
                <label>
                    <input type="checkbox" [(ngModel)]="rememberDevice" name="rememberDevice" />
                    Remember this device for 14 days
                </label>
            </div>
        }
        <div class="form-group">
            <button type="submit" class="btn btn-success" [disabled]="isSubmitting || !code">
                @if (isSubmitting) {
                    <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Verifying</span>
                } @else {
                    <span>Verify</span>
                }
            </button>
        </div>
        @if (sessionMissing) {
            <span style="color: red">Your sign-in expired. Please sign in again.</span>
        }
        @if (lockedOut) {
            <span style="color: red">This account is locked. Try again in 15 minutes or contact IT.</span>
        }
        @if (rateLimited) {
            <span style="color: red">Too many attempts. Please wait and try again.</span>
        }
        @if (failed) {
            <span style="color: red">That code was not correct. Try again.</span>
        }
    </form>
    <div class="text-center">
        <a style="cursor: pointer" (click)="useRecoveryCode = !useRecoveryCode; code = ''; failed = false">
            {{ useRecoveryCode ? 'Use authenticator code' : 'Use a recovery code' }}
        </a>
    </div>
    <div class="text-center" style="margin-top: 8px">
        <a style="cursor: pointer" (click)="backToSignIn()">Back to sign in</a>
    </div>
</div>
